function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _ from 'lodash';
function satisfiesCondition(operator, total, target) {
    if (operator === 'equalTo' && total === target) {
        return true;
    }
    if (operator === 'greaterThan' && total > target) {
        return true;
    }
    return operator === 'greaterThanEqualTo' && total >= target;
}
var getTotalProductCombinations = function(param) {
    var availableEligibleItems = param.availableEligibleItems, comparisonOperator = param.comparisonOperator, numericTarget = param.numericTarget, _param_totalQuantity = param.totalQuantity, totalQuantity = _param_totalQuantity === void 0 ? {} : _param_totalQuantity, _param_propertyName = param.propertyName, propertyName = _param_propertyName === void 0 ? 'weightInMg' : _param_propertyName, _param_accumulateToMaximum = param.accumulateToMaximum, accumulateToMaximum = _param_accumulateToMaximum === void 0 ? false : _param_accumulateToMaximum;
    var tmp = totalQuantity.enabled, totalQuantityEnabled = tmp === void 0 ? false : tmp, tmp1 = totalQuantity.quantity, targetQuantity = tmp1 === void 0 ? 0 : tmp1, _totalQuantity_quantityOperator = totalQuantity.quantityOperator, quantityOperator = _totalQuantity_quantityOperator === void 0 ? 'equalTo' : _totalQuantity_quantityOperator;
    var combinations = [];
    var fork = function() {
        var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, total = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, combo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
            items: {},
            totalQuantity: 0
        };
        var item = availableEligibleItems[index];
        var forkSatisfied = satisfiesCondition(comparisonOperator, total, numericTarget);
        if (forkSatisfied) {
            combinations.push(combo);
            // If weight is equalTo and total quantity is not enabled, we can stop going down this branch here
            if (comparisonOperator === 'equalTo' && !totalQuantityEnabled) {
                return;
            }
        }
        if (!item) {
            return;
        }
        var newTotal = total + item[propertyName] * quantity;
        if (comparisonOperator === 'greaterThanEqualTo' || comparisonOperator === 'greaterThan' || newTotal <= numericTarget) {
            if (item.quantity > quantity) {
                fork(index, quantity + 1, total, combo);
            }
            fork(index + 1, 1, newTotal, {
                items: _object_spread_props(_object_spread({}, combo.items), _define_property({}, item.key, _object_spread_props(_object_spread({}, item), {
                    quantity: quantity
                }))),
                totalQuantity: combo.totalQuantity + quantity
            });
        }
        if (quantity < 2) {
            fork(index + 1, 1, total, combo);
        }
    };
    fork();
    // Filter all combinations that don't match the allowed totalQuantity parameters
    if (totalQuantityEnabled) {
        combinations = _.filter(combinations, function(combo) {
            return quantityOperator === 'greaterThan' ? combo.totalQuantity > targetQuantity : combo.totalQuantity === targetQuantity;
        });
    }
    // If totalWeight is greaterThan on it's own or totalWeight is greaterThan combined with greaterThan totalQuantity,
    // sort combinations by least number of items required to greatest
    if ((comparisonOperator === 'greaterThan' || comparisonOperator === 'greaterThanEqualTo') && (!totalQuantityEnabled || quantityOperator !== 'equalTo')) {
        var sortOrder = accumulateToMaximum ? 'desc' : 'asc';
        combinations = _.uniq(_.orderBy(combinations, 'totalQuantity', sortOrder));
    }
    return _.uniq(combinations);
};
export default getTotalProductCombinations;
